import { AutogenModelCustomFscIndex, AutogenRowCustomFscIndex } from "./autogen/AutogenModelCustomFscIndex";

export class ModelCustomFscIndex extends AutogenModelCustomFscIndex<RowCustomFscIndex> {
	constructor() {
		super(RowCustomFscIndex);
	}
}

export class RowCustomFscIndex extends AutogenRowCustomFscIndex {
}